import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { api } from "@/api/client";

export function HealthPage() {
  const { t } = useTranslation();
  const health = useQuery({
    queryKey: ["health"],
    queryFn: async () => {
      const { data, error } = await api.GET("/api/v1/healthz");
      if (error || !data) throw new Error("health check failed");
      return data;
    },
    refetchInterval: 30_000,
  });

  return (
    <section className="space-y-4">
      <h1 className="text-xl font-semibold">{t("health.title")}</h1>
      {health.isPending && <p className="text-stone-500">{t("health.checking")}</p>}
      {health.isError && (
        <p className="rounded-md bg-red-50 p-3 text-red-700">{t("health.error")}</p>
      )}
      {health.data && (
        <dl className="grid grid-cols-2 gap-3 rounded-lg border border-stone-200 bg-white p-4">
          <dt className="text-stone-500">{t("health.ok")}</dt>
          <dd className="font-medium text-brand-700">{health.data.status}</dd>
          <dt className="text-stone-500">{t("health.database")}</dt>
          <dd className="font-medium">{health.data.database}</dd>
          <dt className="text-stone-500">{t("health.queue")}</dt>
          <dd className="font-medium">{health.data.queue.todo}</dd>
        </dl>
      )}
    </section>
  );
}
